import { React, useEffect, useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Select,
  Button,
  DateRangePicker,
  LoadingComponent,
  Table,
  Modal,
  DownloadButton,
  NoDataFoundTemplate,
  MultiSelect,
} from "../../../components/core";
import { gql, useQuery, useLazyQuery } from "@apollo/client";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
} from "recharts";
import TabComponent from "../../../components/core/tab";
import CustomTooltip from "../../../features/stay-time-in-locker/custom-tooltip";
import {
  NEWEST_LOCKER_NAME_QUERY,
  QUERY_LOCKER_NAME,
  QUERY_LOCKER_TYPE,
  QUERY_STAY_TIME_REPORT,
} from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import StayTimeTable from "../../../features/stay-time-in-locker/custom-table";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { formatDateYYYYMMDD } from "../../../algorithms/date";
import { maxDate } from "../drop-off-status";
import { Card } from "primereact/card";
import { Strings } from "../../../constants/strings";

const StayTimeInLocker = () => {
  //variables
  const dt = useRef(null);
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [lockerName, setLockerName] = useState([]);
  const [lockerType, setLockerType] = useState([]);
  const [startDate, setStartDate] = useState(maxDate);
  const [endDate, setEndDate] = useState(new Date());
  const [isLoading, setisLoading] = useState(false);

  //Setter Variable
  const [noResultSearch, setNoResultSearch] = useState(false);
  const [noDateSelected, setNoDateSelected] = useState(false);
  const [selectedLockerName, setSelectedLockerName] = useState([]);
  const [selectedLockerType, setSelectedLockerType] = useState("-1");
  const [isTableEmpty, setIsTableEmpty] = useState(false);

  //line Chart Datakey
  const [chartData, setChartData] = useState([]);
  const [lineChartValue, setLineChartValue] = useState([]);

  const [tableData, setTableData] = useState([]);

  //sort Day of the week
  const dayToIndex = {
    Sun: 1,
    Mon: 2,
    Tue: 3,
    Wed: 4,
    Thu: 5,
    Fri: 6,
    Sat: 7,
  };

  //Colors For chart
  let COLORS = [
    "rgb(125, 215, 230)",
    "rgb(255, 150, 75)",
    "rgb(180, 60, 200)",
    "rgb(90, 190, 50)",
    "rgb(255, 100, 180)",
    "rgb(70, 120, 255)",
    "rgb(200, 180, 20)",
    "rgb(150, 75, 0)",
    "rgb(40, 170, 120)",
    "rgb(255, 200, 0)",
    "rgb(110, 45, 160)",
    "rgb(0, 255, 100)",
    "rgb(255, 50, 50)",
    "rgb(30, 80, 220)",
    "rgb(210, 160, 20)",
    "rgb(120, 0, 140)",
    "rgb(0, 200, 150)",
    "rgb(255, 80, 0)",
    "rgb(80, 160, 60)",
    "rgb(170, 30, 90)",
  ];

  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const [searchResultHeader, setSearchResultHeader] = useState();
  const [selectedRadio, setSelectedRadio] = useState("daily");
  const [totalLocker, setTotalLocker] = useState([]);
  const [allLockersSelected, setAllLockersSelected] = useState(false);

  function handleSearchResultHeader() {
    const lockerTypeName =
      selectedLockerType === "-1" ? "" : selectedLockerType === "1" ? "" : "";

    const lockerNameValue =
      selectedLockerName != "200"
        ? lockerName.find((item) => item.value === selectedLockerName)
        : "ALL Lockers";
    // selectedLockerName === -1 || selectedLockerName === "200"
    // 	? "ALL Lockers"
    // 	: lockerName.find((item) => item.value === selectedLockerName);

    const lockerNameText = lockerNameValue
      ? `${
          selectedLockerName === "200" ? lockerNameValue : lockerNameValue.name
        }`
      : "ALL Lockers";
    setSearchResultHeader(`for claimed packages
      ${lockerTypeName}
      ${lockerNameText},
	  from ${formatDate(startDate)} to ${formatDate(endDate)}
    `);
  }

  function formatDate(inputDate) {
    if (inputDate == null) {
      return "";
    }
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  //GraphQL
  const [QUERYstayTimeReport, { data, loading }] = useLazyQuery(
    QUERY_STAY_TIME_REPORT,
    { fetchPolicy: "no-cache" }
  );
  const [fetchStayTimeLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
        lockerTypeId: selectedLockerType,
      },
    }
  );
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);

  const generateHSLColor = (index, total, saturation = 70, lightness = 50) => {
    // Distribute hues evenly across the color wheel
    const hue = (index * 360) / Math.max(total, 1);
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };
  const generateColor = (index, total) => {
    // Base colors for first items
    const baseColors = [
      "#8884d8",
      "#82ca9d",
      "#ffc658",
      "#ff7300",
      "#00ff00",
      "#0088fe",
      "#00c49f",
      "#ffbb28",
      "#ff8042",
      "#8dd1e1",
      "#d084d0",
      "#82d982",
      "#ffb347",
      "#87ceeb",
      "#dda0dd",
    ];

    if (index < baseColors.length) {
      return baseColors[index];
    }

    // Generate HSL colors for additional items
    return generateHSLColor(
      index - baseColors.length,
      total - baseColors.length
    );
  };

  //useEffect Para sumahod Table and Chart Data
  console.log({ data });
  useEffect(() => {
    if (data) {
      let tempVar = [];
      let tempVar2 = [];
      var totalPackages = data.lockerStayTimeByHours.reduce(
        (accumulator, element) => {
          accumulator += element.packages;
          return accumulator;
        },
        0
      );

      // If all data is 0, set table data to empty array and show no results
      if (totalPackages === 0) {
        // setTableData([]);
        setisLoading(false);
        setIsError(true);
        // setNoResultSearch(true);
        setIsTableEmpty(true);
        // setValidation({
        //   icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        //   title: "Empty Data",
        //   message: `No result was found.`,
        //   open: true,
        //   actions: (
        //     <div className="w-full">
        //       <Button
        //         onClick={() => setValidation({ open: false })}
        //         value={"OK"}
        //         className={"p-2 w-full"}
        //       />
        //     </div>
        //   ),
        // });
        return; // Exit early since there's no data to process
      }

      // console.log(totalPackages);
      data.lockerStayTimeByHours.forEach((element, index) => {
        //Do this
        let obj = { ...element };
        if (obj.hours >= 16 && obj.hours < 24) {
          obj.hours = `${element.hours} hrs to less than ${
            element.hours + 2
          } hrs`;
        } else if (obj.hours >= 24 && obj.hours < 36) {
          obj.hours = `${element.hours} hrs to less than ${
            element.hours + 3
          } hrs`;
        } else if (obj.hours >= 36 && obj.hours < 72) {
          obj.hours = `${element.hours} hrs to less than ${
            element.hours + 6
          } hrs`;
        } else if (obj.hours >= 72 && obj.hours < 96) {
          obj.hours = `${element.hours} hrs to less than ${
            element.hours + 24
          } hrs`;
        } else if (obj.hours === 96) {
          obj.hours = `${element.hours} hrs and above`;
        } else {
          obj.hours = `${element.hours} hrs to less than ${
            element.hours + 1
          } hrs`;
        }

        obj.percent = `${((obj.packages / totalPackages) * 100).toFixed(2)}%`;
        tempVar.push(obj);

        let tempData = [];
        let tempArr1 = [];
        let temp3 = [];
        data.lockerStayTimeByHours.forEach((element, index) => {
          let tempArr = [];
          //to get datas inside periods
          element.periods.forEach((e, i) => {
            tempArr.push({ [e.name]: e.packages });
            if (!tempArr1.includes(e.name)) {
              tempArr1.push(e.name);
              temp3.push({ id: e.periodId, name: e.name });
            }
            tempArr.push(e.periodId);
          });
          //using reduce to combine object
          tempArr.push({ hours: element.hours });
          const combinedObject = tempArr.reduce(
            (acc, obj) => ({ ...acc, ...obj }),
            {}
          );
          tempData.push(combinedObject);
        });

        let tempLine = [];
        //to Sort Period
        if (selectedRadio === "daily") {
          const sortPeriod = tempArr1.sort(
            (a, b) => dayToIndex[a] - dayToIndex[b]
          );
          sortPeriod.forEach((e, i) => {
            const dynamicColor = generateColor(i, sortPeriod.length);

            tempLine.push(
              <Line
                dataKey={e}
                // stroke={COLORS[i % 8]}
                stroke={dynamicColor}
                label={e}
                dot={{ stroke: dynamicColor, strokeWidth: 6 }}

                // dot={{ stroke: `${COLORS[i % 20]}`, strokeWidth: 6 }}
              />
            );
          });
        } else if (selectedRadio === "weekly") {
          const sortPeriod = temp3.sort(
            (a, b) => parseInt(a.id) - parseInt(b.id)
          );
          sortPeriod.forEach((e, i) => {
            const dynamicColor = generateColor(i, sortPeriod.length);
            tempLine.push(
              <Line
                dataKey={e.name}
                // stroke={COLORS[i % 8]}
                stroke={dynamicColor}
                label={e.name}
                dot={{ stroke: dynamicColor, strokeWidth: 6 }}

                // dot={{ stroke: `${COLORS[i % 20]}`, strokeWidth: 6 }}
              />
            );
          });
        } else if (selectedRadio === "weekday") {
          const sortPeriod = tempArr1.sort(
            (a, b) => dayToIndex[a] - dayToIndex[b]
          );

          sortPeriod.forEach((e, i) => {
            const dynamicColor = generateColor(i, sortPeriod.length);
            tempLine.push(
              <Line
                dataKey={e}
                // stroke={COLORS[i % 8]}
                stroke={dynamicColor}
                label={e.name}
                dot={{ stroke: dynamicColor, strokeWidth: 6 }}
                // dot={{ stroke: `${COLORS[i % 20]}`, strokeWidth: 6 }}
              />
            );
          });
        } else if (selectedRadio === "monthly") {
          const sortPeriod = temp3.sort(
            (a, b) => parseInt(a.id) - parseInt(b.id)
          );
          sortPeriod.forEach((e, i) => {
            const dynamicColor = generateColor(i, sortPeriod.length);
            tempLine.push(
              <Line
                dataKey={e.name}
                // stroke={COLORS[i % 8]}
                stroke={dynamicColor}
                label={e.name}
                dot={{ stroke: dynamicColor, strokeWidth: 6 }}

                // dot={{ stroke: `${COLORS[i % 20]}`, strokeWidth: 6 }}
              />
            );
          });
        } else if (selectedRadio === "yearly") {
          const sortPeriod = tempArr1.sort((a, b) => a - b);
          sortPeriod.forEach((e, i) => {
            const dynamicColor = generateColor(i, sortPeriod.length);
            tempLine.push(
              <Line
                dataKey={e}
                // stroke={COLORS[i % 8]}
                label={e}
                stroke={dynamicColor}
                dot={{ stroke: dynamicColor, strokeWidth: 6 }}
                // dot={{ stroke: `${COLORS[i % 20]}`, strokeWidth: 6 }}
              />
            );
          });
        }
        setLineChartValue(tempLine);
        setChartData(tempData);
      });

      setTableData(tempVar);
      setisLoading(false);
    }
  }, [data]);

  //To fetch locker Type
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) =>
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        })
      );
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  //To Fetch LockerName
  useEffect(() => {
    if (selectedLockerType !== "-1") {
      fetchStayTimeLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: selectedLockerType,
        },
      });
    }
  }, [selectedLockerType, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);
  useEffect(() => {
    const selected = selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [selectedLockerName, lockerName]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setSelectedLockerName(selectedLockers);
    }
  }, [allLockersSelected, lockerName]);

  //Period Tab select handler

  const handleTabClick = (tabValue) => {
    setSelectedRadio(tabValue);
    const start = formatDateYYYYMMDD(startDate);
    const end = formatDateYYYYMMDD(endDate);
    const mappedLockerNames = selectedLockerName.map((locker) => locker.value);

    let searchVars = {
      operatorId: operatorId,
      dateStart: start,
      dateEnd: end,
      selectedLockerName: mappedLockerNames,
      selectedRadio: tabValue,
    };

    if (selectedLockerName.length === 0) {
      delete searchVars.selectedLockerName;
    }
    QUERYstayTimeReport({
      variables: searchVars,
    });
  };

  const [isError, setIsError] = useState(false);

  const buildVariables = () => {
    const start = formatDateYYYYMMDD(startDate);
    const end = formatDateYYYYMMDD(endDate);

    const updatedVariables = {
      operatorId: operatorId,
      dateStart: start,
      dateEnd: end,
      selectedRadio: selectedRadio,
      selectedLockerType: selectedLockerType,
    };

    // Check each state and add to updatedVariables if not empty
    if (selectedLockerType !== "-1") {
      if (selectedLockerName.length === 0) {
        setChartData([]);
        setTableData([]);
        setIsError(false);
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Invalid Locker",
          message: `Please select a locker name.`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        const mappedLockerNames = selectedLockerName.map(
          (locker) => locker.value
        );

        if (selectedLockerName.length !== 0) {
          updatedVariables.selectedLockerName = mappedLockerNames;
          setIsError(false);
        }
      }
    } else {
      setIsError(false);
    }
    return updatedVariables;
  };
  function EmptyLockerHandler() {
    const variable = buildVariables();
    if (selectedLockerType != "-1" && selectedLockerName.length === 0) {
      setisLoading(false);
      setIsTableEmpty(true);
      return;
    } else {
      setIsTableEmpty(false);
      QUERYstayTimeReport({
        variables: variable,
      });
    }
  }
  const handleSearch = (event, data) => {
    setisLoading(true);
    handleSearchResultHeader();
    EmptyLockerHandler();
    setTableData([]);

    if (selectedLockerType !== "-1" && selectedLockerName.length === 0) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_search_criteria,
        message: Strings.popup_error_lockername,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);
      setisLoading(false);
      return;
    }
    if (startDate == "" && endDate == "") {
      setNoDateSelected(true);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `Please select a date range.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);

      setisLoading(false);
      return;
    } else if (endDate == "") {
      setNoDateSelected(true);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `No end date was selected.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);

      setisLoading(false);
      return;
    } else if (endDate < startDate) {
      setNoDateSelected(true);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `Start date must be before end date.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);

      setisLoading(false);
      return;
    } else if (startDate == "") {
      setNoDateSelected(true);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Date",
        message: `No start date was selected.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);
      setisLoading(false);

      return;
    } else {
      setNoDateSelected(false);
    }
  };

  return (
    <ContentContainer containerTitle="Staytime in Locker Report">
      <div>
        <h2 className={"font-bold"}>Locker:</h2>
        <div className={"grid grid-cols-6 w-full gap-y-2 pb-2"}>
          <p className="col-span-1">Locker Type:</p>
          <Select
            items={lockerType}
            className={"col-span-3"}
            value={selectedLockerType}
            defaultOption={{ value: "-1", name: "-- ALL --" }}
            onChange={(event) => {
              setSelectedLockerType(event.target.value);

              setSelectedLockerName([]);
            }}
          />
          <div className="col-span-2"></div>

          <p className="col-span-1">Locker Name:</p>
          <MultiSelect
            items={lockerName}
            className={"col-span-3"}
            value={selectedLockerName}
            defaultOption={{ value: "-1", name: "-- Select Locker Name --" }}
            placeholder={`${
              selectedLockerType === "-1" ? "ALL Lockers" : "Select..."
            }`}
            disabled={selectedLockerType === "-1"}
            onChange={(event) => {
              setSelectedLockerName(event.target.value);
            }}
          />
        </div>
        <div className={"grid grid-cols-2 w-1/2 gap-y-2 pb-2"}>
          <h1 className={"font-bold pb-2 col-span-2"}>Date range:</h1>
          {/* <DateRangePicker
					className={"w-1/2"}
					startDate={startDate}
					endDate={endDate}
					onChange={(event) => {
						if (event.target.name === "signupDateFrom") {
							setStartDate(event.target.value);
						} else {
							setEndDate(event.target.value);
						}
					}}
				/> */}
          <PrimereactDateRange
            className={"col-span-2"}
            startDate={startDate}
            readOnlyInput={true}
            max={new Date()} // Today's date as the maximum
            min={new Date("2021-01-01")}
            endDate={endDate}
            onChange={(event) => {
              if (event.target.name === "signupDateFrom") {
                setStartDate(event.target.value);
              } else {
                setEndDate(event.target.value);
              }
            }}
          />
        </div>
        <div className="grid grid-cols-2 w-1/2 gap-y-2">
          <div></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              setSelectedLockerType("-1");
              setSelectedLockerName([]);
              setStartDate(maxDate);
              setEndDate(new Date());
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>
        <Button
          value={"SEARCH"}
          onClick={(event) => {
            setisLoading(true);
            handleSearch(event, data);
          }}
          className={"w-40 h-8 m-5"}
        />
        {isLoading && <LoadingComponent />}

        {isTableEmpty && isError && <NoDataFoundTemplate />}
        {tableData.length > 0 && !isTableEmpty && (
          <div className="px-4">
            <Card>
              <DownloadButton id="Stay Time in Locker" pngOnly={true} />
              <div className="bg-yellow-400 h-1"></div>
              <div id="Stay Time in Locker">
                {tableData.length > 0 && isTableEmpty === false && (
                  <div className={"mb-5 border-black border"}>
                    <div className={" grid grid-row-2 p-2 bg-yellow-400"}>
                      <div>
                        <TabComponent
                          selectedRadio={selectedRadio}
                          tabs={[
                            {
                              value: "daily",
                              title: "Daily",
                            },
                            {
                              value: "weekly",
                              title: "Weekly",
                            },
                            {
                              value: "weekday",
                              title: "Day of the Week",
                            },
                            {
                              value: "monthly",
                              title: "Monthly",
                            },
                            {
                              value: "yearly",
                              title: "Yearly",
                            },
                          ]}
                          onTabClick={handleTabClick}
                        />
                      </div>
                      <div className="text-center">
                        <h1 className={"font-bold"}>
                          STAYTIME IN LOCKER REPORT
                        </h1>
                        <h1 className={"font-bold"}>{searchResultHeader}</h1>
                      </div>
                    </div>
                  </div>
                )}
                {tableData.length > 0 && !isTableEmpty && (
                  <div className="pt-5 pb-5 justify-center text-center mt-5 border-solid border border-black">
                    <LineChart
                      className="mx-auto"
                      width={900}
                      height={400}
                      data={chartData}
                      margin={{ top: 5, right: 30, left: 20, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <Tooltip content={<CustomTooltip />} />
                      <XAxis dataKey="hours">
                        <Label
                          value={"Hours"}
                          position={"insideBottom"}
                          offset={-5}
                        />
                      </XAxis>
                      <YAxis>
                        <Label
                          value={"Packages"}
                          angle={-90}
                          position={"insideLeft"}
                        />
                      </YAxis>
                      <Legend
                        verticalAlign="middle"
                        layout="vertical"
                        align="left"
                        wrapperStyle={{
                          padding: "0 0rem",
                          height: "80%",
                          overflow: "auto",
                          position: "absolute",
                        }}
                      />
                      {lineChartValue}
                    </LineChart>

                    {/* table */}
                    <DownloadButton
                      id="Stay Time in Locker"
                      dt={dt}
                      csvOnly={true}
                    />
                    <StayTimeTable
                      dt={dt}
                      headers={[
                        {
                          header_name: "Stay Duration",
                          header_key: "hours",
                        },
                        {
                          header_name: "Total Packages",
                          header_key: "packages",
                        },
                        {
                          header_name: "Percentage",
                          header_key: "percent",
                        },
                      ]}
                      items={tableData}
                    />
                  </div>
                )}
              </div>
            </Card>
          </div>
        )}

        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </div>
    </ContentContainer>
  );
};
export default StayTimeInLocker;
